
export enum AIToolNameEnum {
  GOLD_START = '黄金开场',
  TITLE = '智能标题',
  DESCRIPTION = '智能描述',
  REWRITE = '智能改写'
}

export enum AIToolSourceEnum {
  GOLD_START = 'AI_GOLD_START',
  TITLE = 'AI_TITLE',
  DESCRIPTION = 'AI_DESCRIPTION',
  REWRITE = 'AI_REWRITE'
}

export enum AIGenerateStatusEnum {
  PENDING = 'Pending',
  GENERATING = 'Generating',
  FINISH = 'Finish'
}
